module.exports = __webpack_public_path__ + "img/ring_y_i_0_0@3x.9952516b.png";